import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';

import Flex from '../../layouts/Flex';

const Container = styled(Flex)(
  ({ width = '32px' }) =>
    css({
      flexDirection: 'column',
      flexShrink: 0,
      verticalAlign: 'top',
      top: 'decorationLine.top',
      position: 'relative',
      boxSizing: 'border-box',
      alignItems: 'center',
      width: width,
    }),
  variant({
    prop: 'iconBackground',
    variants: {
      false: {
        top: 'decorationLine.offset',
      },
    },
  }),
  variant({
    prop: 'alignTop',
    variants: {
      true: {
        top: '0px',
      },
    },
  }),
  variant({
    prop: 'circleDotTop',
    variants: {
      true: {
        top: 2,
      },
    },
  })
);

export default Container;
